export default __webpack_public_path__ + "static/media/caenmini.990088a3.jpg";